export const FONT_PRIMARY = '#3D3D3F'
export const FONT_HIGHLIGHT = '#244D4D'

export const PRIMARY_COLOR = '#FCFCFC'
export const SECONDARY_COLOR = '#E0F0F0'